module.exports = __webpack_public_path__ + "img/1_AR.1f6283f0.png";